/**
 * Ryan O'Dowd
 * 2025-05-09
 * © Copyright 2025 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import 'react-circular-progressbar/dist/styles.css';
import {
  CircularProgressbarWithChildren,
  buildStyles,
} from 'react-circular-progressbar';
import React from 'react';
import {
  View,
} from 'react-native';
import getStyles from './styles';
import hooks from '@hooks';

const AnimatedRings = (props: AnimatedRingsProps) => {
  const styles = hooks.useStyles(getStyles);

  // @NOTE: strokeWidth is a percentage of the width, not a pixel value
  const strokeWidth = props.width / props.size * 100;

  return (
    <View style={styles.container(props.size)}>
      <CircularProgressbarWithChildren
        value={props.inProgressFillPercent}
        styles={buildStyles({
          pathColor: styles.colors.complete,
          trailColor: styles.colors.qqq,
          // @TODO: strokeLinecap: 'butt', // @TODO: this is not consisten with native, but it looks better (native has a black spacer which is best for a11y)
        })}
        strokeWidth={strokeWidth}
      >
        <CircularProgressbarWithChildren
          value={props.masteredFillPercent}
          styles={buildStyles({
            pathColor: styles.colors.accent,
            trailColor: 'transparent',
            // @TODO: strokeLinecap: 'butt',
          })}
          strokeWidth={strokeWidth}
        >
          {typeof props.children === 'function' ? props.children() : props.children}
        </CircularProgressbarWithChildren>
      </CircularProgressbarWithChildren>
    </View>
  );
};

class AnimatedRingsProps { // @TODO: combine with native
  children: React.ReactNode | (() => React.ReactNode);
  size: number;
  width: number;
  unstartedFillPercent: number;
  inProgressFillPercent: number;
  masteredFillPercent: number;
  rotation: number;

  totalNum?: number;
  color?: string;
  prefill?: number;
};

export default AnimatedRings;
